import { objectOf } from "@altostra/type-validations";

import { isCalculatedAttributeEngagements } from "@dashboardApi/apis/apiCalculatedAttributesAppGroupIdDeactivate";

export const isGetApiCalculatedAttributesIdAppGroupIdEngagementsResult = objectOf({
  engagements: isCalculatedAttributeEngagements,
});
